export default {
    data() {
        return {
            headerCsvParsed: [],
            dataCsvParsed: [],
        };
    },
    methods: {
        readFile(evt) {
            if (!evt) return
            let file = evt;
            let reader = new FileReader();
            reader.onload = (e) => {
                this.csvJSON(e.target.result)
            };
            reader.readAsBinaryString(file);
        },
        csvJSON(csv) {
            let lines = csv.split("\n");
            let result = [];
            let headers = lines[0].split(",");
            for (let o = 1; o < lines.length; o++) {
                let obj = {};
                const currentline = lines[o].split(",");
                for (let j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j];
                }
                result.push(obj);
            }
            this.dataCsvParsed = result;

            for (const element of headers) {
                this.headerCsvParsed.push({text: element, value: element})
            }
        }
    }
}
